import { fetchApi } from '@/shared/api/fetchApi';
import { Employee, EmployeeRole, PiccoloUser } from '../types/profile.types';

export type UpdateUserProfileDto = Partial<Pick<PiccoloUser, 'first_name' | 'last_name'>>;
export type UpdateEmployeeProfileDto = Partial<Pick<Employee, 'email' | 'phone' | 'telegram_username'>>;

export const profileApi = {
  getUserProfile: (userId: string) => {
    return fetchApi<PiccoloUser>(`/admin/api/tables/piccolo_user/${userId}/`);
  },

  updateUserProfile: (userId: string, data: UpdateUserProfileDto) => {
    return fetchApi<PiccoloUser>(`/admin/api/tables/piccolo_user/${userId}/`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  },

  getEmployeeProfile: (userId: string) => {
    return fetchApi<{ rows: Employee[] }>(`/admin/api/tables/employee/?user=${userId}`);
  },

  updateEmployeeProfile: (employeeId: string, data: UpdateEmployeeProfileDto) => {
    return fetchApi<Employee>(`/admin/api/tables/employee/${employeeId}/`, {
      method: 'PATCH',
      body: JSON.stringify(data)
    });
  },

  getEmployeeRole: (roleId: string) => {
    return fetchApi<EmployeeRole>(`/admin/api/tables/employee_role/${roleId}/`);
  }
};
